const CHANGE_CALENDAR = "CHANGE_CALENDAR";

const handleChangeCalendar = (type) => ({
  type: CHANGE_CALENDAR,
  payload: {
    type
  }
});

export {handleChangeCalendar, CHANGE_CALENDAR};
